export const apiUrl = process.env.NEXT_PUBLIC_API_URL;
export const baseUrl = process.env.NEXT_PUBLIC_API_URL;
export const apiPrefix = process.env.NEXT_PUBLIC_API_PREFIX;

export const googleTrackingID = process.env.NEXT_PUBLIC_GOOGLE_TRACKING_ID;
export const appName = process.env.NEXT_PUBLIC_APP_NAME;
export const appWebsite = process.env.NEXT_PUBLIC_APP_WEBSITE;
export const devName = process.env.NEXT_PUBLIC_DEV_NAME;
export const devWebsite = process.env.NEXT_PUBLIC_DEV_WEBSITE;
export const classPrefix = process.env.NEXT_PUBLIC_CLASS_PREFIX;

export const googleMapApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
export const googleMapDefaultLocation = {
  lat: parseFloat(process.env.NEXT_PUBLIC_GOOGLE_MAP_LAT),
  lng: parseFloat(process.env.NEXT_PUBLIC_GOOGLE_MAP_LNG),
};
export const googleMapCountryList = process.env.NEXT_PUBLIC_GOOGLE_MAP_COUNTRIES.split(',');
export const googleMapDefaultZoom = parseInt(process.env.NEXT_PUBLIC_GOOGLE_MAP_ZOOM, 10);

export const timezone = process.env.NEXT_PUBLIC_TIMEZONE;
export const fbID = process.env.NEXT_PUBLIC_FB_ID;
export const fbPageID = process.env.NEXT_PUBLIC_FB_PAGE_ID;

export const siteTitle = process.env.NEXT_PUBLIC_SITE_TITLE;
export const siteTagLine = process.env.NEXT_PUBLIC_SITE_TAGLINE;
export const metaDesc = process.env.NEXT_PUBLIC_META_DESC;
export const metaKeywords = process.env.NEXT_PUBLIC_META_KEYWORDS;
